import React, { useEffect, useState } from 'react';
import { ThemeProvider as MuiThemeProvider, Theme } from '@mui/material/styles';
import { UptimeMarketplaceThemeProvider } from '@uptime/uptime-component';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';
import LoadingScreenWithBackdrop from 'components/LoadingScreenWithBackdrop';
import { marketplaceTheme } from 'theme/marketplaceTheme';
type TMarketplaceThemeProvider = {
  children: React.ReactNode;
};

export const useMarketplaceThemeConfig = () => {
  const [theme, setTheme] = useState<Theme>(marketplaceTheme);
  const { marketplaceTheme: marketplaceThemeProvider } = useSelector(
    (state: RootState) => state.marketplaceReducer,
  );
  useEffect(() => {
    setTheme(prevTheme => ({
      ...prevTheme,
      ...marketplaceTheme,
      typography: {
        ...prevTheme.typography,
        ...marketplaceTheme.typography,
        ...(marketplaceThemeProvider?.typography || {})
      },
      palette: { ...prevTheme.palette, ...marketplaceTheme.palette, ...(marketplaceThemeProvider?.palette || {}) },
    }));
  }, [marketplaceThemeProvider]);

  return theme;
};

const MarketplaceThemeProvider = ({ children }: TMarketplaceThemeProvider) => {
  const theme = useMarketplaceThemeConfig();
  if (Object.keys(theme).length === 0) {
    return <><LoadingScreenWithBackdrop isOpen={true} /></>
  }
  
  return (
    <MuiThemeProvider theme={theme}>
      <UptimeMarketplaceThemeProvider theme={theme}>
        {children}
      </UptimeMarketplaceThemeProvider>
    </MuiThemeProvider>
  );
};

export default MarketplaceThemeProvider;
